'use client'

import { Icon } from '@/icons/Icon'
import { ResultItemProps } from '@/types/app'
import { cn, slugMap, getLabel } from '@/lib/utils'
import Link from '@/components/ui/Link'
import type { HomepageChip } from '@/app/(app)/fetchers'

// Not driven by featured order like the other chips — there's no single "featured
// stack" concept to key off, so this one stays fixed.
const STACK_SUGGESTION: ResultItemProps = {
  label: 'small business',
  type: 'stack',
  slug: 'small-business',
}

type ChatSuggestionsProps = {
  chips: HomepageChip[]
}

export default function ChatSuggestions({ chips }: ChatSuggestionsProps) {
  const suggestions: ResultItemProps[] = [...chips, STACK_SUGGESTION]

  const renderSuggestion = (text: string | undefined) => {
    const parts = text?.split(' ')
    return parts?.map((part, idx) => {
      const isMention = part.startsWith('@')
      return (
        <span key={`${part}-${idx}`} className={isMention ? 'text-primary-500' : undefined}>
          {part}
          {idx < parts.length - 1 ? ' ' : ''}
        </span>
      )
    })
  }

  return (
    <div className="mx-auto flex flex-wrap justify-center gap-3 px-3">
      {suggestions.map((suggestion, index) => (
        <Link
          href={`/${slugMap[suggestion.type]}/${suggestion.slug}`}
          key={`${suggestion.type}-${suggestion.label}`}
          className={cn(
            'h-8 shrink-0 items-center gap-2.5 rounded-xl bg-gray-950/5 px-3 text-13 text-gray-950 backdrop-blur-md transition-colors hover:bg-gray-950/10',
            index === 4 ? 'hidden lg:flex' : index === 3 ? 'hidden md:flex' : 'flex',
          )}
        >
          <Icon name={suggestion.type} size={12} />
          <div className="flex items-center gap-1">
            <span className="text-gray-600">/{getLabel(suggestion.type)}</span>
            <p>{renderSuggestion(suggestion.label)}</p>
          </div>
        </Link>
      ))}
    </div>
  )
}
